(function () {
  function initHeroMaps() {
    if (typeof L === 'undefined') return;

    document.querySelectorAll('[data-ccs-hero-map]').forEach(function (el) {
      if (el.dataset.initialized === 'true') return;

      var lat = parseFloat(el.dataset.lat);
      var lng = parseFloat(el.dataset.lng);
      var zoom = parseInt(el.dataset.zoom, 10);

      if (Number.isNaN(lat)) lat = -27.4698;
      if (Number.isNaN(lng)) lng = 153.0251;
      if (Number.isNaN(zoom)) zoom = 7;

      var map = L.map(el, {
        scrollWheelZoom: false,
        zoomControl: true,
        attributionControl: true,
      }).setView([lat, lng], zoom);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '© OpenStreetMap contributors',
      }).addTo(map);

      try {
        var markers = JSON.parse(el.dataset.markers || '[]');
        markers.forEach(function (marker) {
          if (!marker.lat || !marker.lng) return;
          L.marker([marker.lat, marker.lng]).addTo(map).bindPopup(marker.title || '');
        });
      } catch (e) {
        /* ignore malformed marker JSON */
      }

      el.dataset.initialized = 'true';

      requestAnimationFrame(function () {
        map.invalidateSize();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroMaps);
  } else {
    initHeroMaps();
  }

  document.addEventListener('shopify:section:load', initHeroMaps);
})();
